export default {
    AccountManagement: {
        staffLeave: {
            importLeave: '请假导入',
            viewLeave: '查看请假信息',
            records: '请假记录',
            refresh: '刷新',
            empty: '暂无请假记录',
            loadFailed: '请假记录加载失败，请点击刷新重试',
            serialNumber: '序号',
            createPerson: '创建人',
            createPersonDept: '创建人部门',
            type: '请假类型',
            startTime: '开始时间',
            endTime: '结束时间',
            leaveHours: '请假时长（小时）',
            noPayLeave: '是否无薪假',
            duration: '持续时长',
            approveResult: '审批结果',
            approveStatus: '审批状态',
            leaveReason: '请假理由',
            createTime: '创建时间',
        },
        staff: {
            name: '员工姓名',
            legalName: '法定姓名',
            preferredName: '常用姓名',
            type: '种类',
            department: '部门',
            role: '工种',
            hourlyRateWithLeave: '含 Leave 时薪',
            regularHourlyRate: '普通时薪',
            decryptRates: '解密',
            privateKey: '私钥',
            privateKeyPlaceholder: '请输入或上传私钥',
            uploadPrivateKey: '上传私钥',
            privateKeyRequired: '请输入或上传私钥',
            decryptSuccess: '解密成功',
            decryptFailed: '解密失败，请检查私钥或密文',
            encryptFailed: '加密失败，请重试',
            Full: '全职',
            Casual: '兼职',
            Hire: '长期劳务外包',
            Inbound: '入库',
            Outbound: '出库',
        },
        dept: {
            Management: '仓库部门管理',
            department: '部门',
            supervisor: '主管',
        },
        work: {
            review: '审核',
            reviewTitle: '工时总览',
            reviewAll: '全部可见部门',
            reviewRefresh: '刷新',
            reviewGap: '中间断档',
            reviewGapCount: '发现{count}处工时中间断档，已用橙色标识。首段开始前、末段结束后的空白不作提示。',
            reviewFullDay: '00:00–24:00 · 每格30分钟 · 左右滚动查看全天',
            reviewLocate: '定位首段加班',
            reviewRequestError: '工时数据加载失败，请刷新重试。',
            reviewOvertime: '加班申请',
            reviewNote: '每格30分钟，颜色表示工时记录所属部门。筛选后保留匹配人员的全部记录，红色表示重叠，橙色表示中间断档。实际工时与加班申请分别查看。',
            reviewInvalid: '{count}条记录缺少有效起止时间，无法展示。',
            reviewConflict: '发现{count}组工时记录重叠，请检查红框工时条及下方明细。',
            reviewOverlap: '时间重叠',
            reviewPeople: '{count}人',
            reviewEmpty: '该日期和部门暂无工时记录。',
            reviewLoadError: '数据不完整，以下部门加载失败：{departments}。请刷新重试，当前重叠检查结果不完整。',
            reviewNoDepartments: '暂无可用部门，请等待部门列表加载后刷新。',
            weekDay: '日期',
            recommended: '推荐用人',
            plan: '计划用人',
            actual: '实际用人',
            over: '加班',
            fill: '填写计划用人',
            staffSelect: '选择仓库人员',
            labour: '劳务外包',
            num: '人数',
            name: '姓名',
            role: '工种',
            ReasonTitle: '超出原因',
            enterReason: '请填写超用人工原因',
            fillActual: '填写该日实际用人',
            hour: '工作时长',
            Overtime: '加班申请',
            info: '员工信息',
            Reason: '原因',
            Headcount: '用工审批状态',
            Overtime: '加班审批状态',
            targetGroup: '部门',
            percentage: '百分比',
            action: '操作',
            addGroup: '新增',
            close: '关闭',
            allocate: '分配',
            count: '序号',
            exportTimesheetReport: '导出工时报表',
            employeeType: '员工类型',
            fullTime: '全职',
            casual: '兼职',
            fullTimeOnly: '（仅全职员工）',
            casualOnly: '（仅兼职员工）',
            labourHireSection: '劳务派遣',
            labourHireOnly: '（仅劳务派遣员工）',
            fullTimeBiWeekly: '全职（双周）',
            casualWeekly: '兼职（周）',
            labourHire: '劳务派遣',
            period: '周期',
            pleaseSelect: '请选择',
            workDetailsDuplicateDept: '{module}第{row}行部门有重复值',
            workDetailsPercentageNotEqual100: '{module}第{row}行百分比不等于100',
            workDetailsDataError: '{module}第{row}行数据错误',
        },
        common: {
            account: '账户',
            name: '名称',
            belongto: '归属',
            tenantName: '所属租户',
            status: '账户状态',
            Whether: '是否锁定',
            Expired: '是否过期',
            customer: '客户',
            cusName: '所属客户',
            from: '有效期从',
            until: '有效期至',
            New: '新增账户',
            NewCustom: '新增客户',
            edit: '编辑',
            Info: '修改账单信息',
            operate: '操作',
            structure: '关联组织架构',
            Change: '修改密码',
            lock: '锁定',
            deblocking: '解锁',
            freeze: '冻结',
            unfreeze: '解冻',
            isfreeze: '是否冻结',
            isLeave: '离场状态',
            Leave: '确认离场',
            Back: '取消离场',
            termOfProtection: '宽限期',
            password: '密码',
            Confirm: '确认密码',
            ps: '请输入密码',
            ps1: '请输入6至20位密码',
            ps2: '请再次输入密码',
            ps3: '两次输入密码不一致!',
            ps4: '您正在',
            ps5: '是否继续 ？',
            ps6: '操作成功',
            ps7: '相关状态都已经禁用，该客户已改成离场状态。',
        },
        customer: {
            account: '客户编码',
            name: '客户名称',
            status: '客户状态',
            companyName: '公司名称',
            activationTime: '启用日期',
            deactivationTime: '停用日期'
        },
        table: {
            phone: '手机',
            email: '邮箱',
            creator: '创建人',
            createTime: '创建时间',
            disableTip: '因账户关闭而禁用',
            freezeTip: '因账户欠费而冻结',
            lockTip: '因账户密码错误太多而锁定'
        },
        backup:{
            Contract: '合同',
            Rate: '价格表',
            Terms: '服务条款',
            Credit: '信用申请表',
            Inbound: 'Inbound检查表',
            Internal: '内部交接表',
            IT: 'IT 检查表',
            Others: '其他',
        },
        dashboard:{
            Onboarding: '入场进度概览',
            Total: '入场客户总数',
            Pending: '待审批客户',
            Initial: '已进入初始运营阶段',
            SKU: '产品（SKU）',
            Store: '店铺',
            PO: '采购订单（PO）',
            Order: '客户订单',
            Tracker: '客户进程详情',
            Customer: '客户',
            SKUi: '产品信息（SKU）',
            SKUFirst: '首个产品创建',
            SKUCurrent: '当前产品数量',
            SKUEstimated: '预计产品数量',
            Complete: '完成',
            Storei: '店铺信息',
            StoreFirst: '首个店铺创建',
            StoreAPI: 'API测试',
            POi: '采购订单',
            POFirst: '首个PO创建',
            POArrived: '首个PO到货',
            POReceived: '首个PO收货完成',
            Orderi: '客户订单',
            OrderFirst: '首个订单抓取',
            OrderDispatched: '首个订单发货',
        },
    }
};
